<template>
  <div>
    <span>
      <h1>Parcelamento Contrato: {{ numeroContrato }}</h1>
    </span>
    <v-flex xs6 sm6 md4>
      <v-layout row align-center justify-space-between>
        <v-flex grow pa-1>
          <span>
            Data base cálculo
          </span>
        </v-flex>
        <v-flex grow pa-1>
          <v-text-field
            readonly
            height="18px"
            :value="dadosFatura.dataBaseParcelamento"
          />
        </v-flex>
      </v-layout>
    </v-flex>

    <v-data-table
      class="elevation-5 my-4 mx-1"
      no-data-text="Não há registros"
      rows-per-page-text="Linhas por página"
      :headers="headers"
      :items="[dadosFatura]"
      :loading="isLoading"
      :pagination.sync="pagination"
      :total-items="+numberOfElementsFaturas"
      :rows-per-page-items="pageOptions"
    >
      <template v-slot:items="props">
        <td>{{ props.item.numeroDocumento }}</td>
        <td>{{ props.item.dataCobranca }}</td>
        <td>{{ props.item.perJuros }}</td>
        <td>{{ `R$ ${props.item.valorJuros || "0"}` }}</td>
        <td>{{ props.item.perMulta }}</td>
        <td>{{ `R$ ${props.item.valorMulta || "0"}` }}</td>
        <td>{{ `R$ ${props.item.valorFatura || "0"}` }}</td>
        <td>{{ `R$ ${props.item.valorImpostos || "0"}` }}</td>
        <td>{{ `R$ ${props.item.valorLiquido || "0"}` }}</td>
        <td>{{ `R$ ${props.item.valorPrevisto || "0"}` }}</td>
      </template>
    </v-data-table>
    <v-flex xs6 sm6 md4>
      <v-layout row align-center justify-space-between>
        <v-flex grow pa-1>
          <span>
            Data do primeiro vencimento
          </span>
        </v-flex>
        <v-flex grow pa-1>
          <date-picker
            is-edit-mode
            placeholder="00/00/0000"
            :date="dadosFatura.dataPrimVencimento"
            :min="currentDateWithoutTime()"
            :rules="[
              required,
              validDate,
              maxDatePrimeiroVencimento(
                formatDateRestore(
                  initialStateFaturaSelected.dataPrimVencimento
                ),
                dadosFatura.dataPrimVencimento
              )
            ]"
            @change="
              value =>
                updateField({
                  property: 'dataPrimVencimento',
                  value: formatDate(value)
                })
            "
            @input="
              value =>
                updateField({
                  property: 'dataPrimVencimento',
                  value: formatDate(value)
                })
            "
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs6 sm6 md4>
      <v-layout row align-center justify-space-between>
        <v-flex grow pa-1>
          <span>
            Valor de entrada
          </span>
        </v-flex>
        <v-flex grow pa-1>
          <v-text-field
            ref="valorEntradaField"
            v-model="dadosFatura.valorEntrada"
            single-line
            prefix="R$"
            @input="value => updateValorEntrada(value)"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const portalStore = createNamespacedHelpers("portal");

import DatePicker from "@/components/DatePicker";
import {
  currentDateWithoutTime,
  formatDate,
  formatDateRestore
} from "@/utils/date";
import {
  required,
  validDate,
  maxDatePrimeiroVencimento
} from "@/utils/validation-rules";

export default {
  name: "CorrigirCobranca",
  props: {
    numeroContrato: String,
    dadosFatura: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    DatePicker
  },
  data() {
    return {
      currentDateWithoutTime,
      formatDate,
      formatDateRestore,
      maxDatePrimeiroVencimento,
      required,
      validDate,
      pageOptions: [5, 10, 25, { value: -1, text: "Todos" }],
      isLoading: false,
      pagination: {
        page: 1,
        rowsPerPage: 5,
        sortBy: "numeroDocumento",
        descending: true
      },
      headers: [
        { text: "Nº Documento", value: "numeroDocumento", class: "px-2" },
        {
          text: "Data Cobranca",
          value: "dataCobranca",
          sortable: false,
          class: "px-2",
          width: 100
        },
        { text: "% Juros", value: "perJuros", sortable: false, class: "px-2" },
        { text: "Juros", value: "valorJuros", sortable: false, class: "px-2" },
        { text: "% Multa", value: "perMulta", sortable: false, class: "px-2" },
        { text: "Multa", value: "valorMulta", sortable: false, class: "px-2" },
        {
          text: "Valor Fatura",
          value: "valorFatura",
          sortable: false,
          class: "px-2"
        },
        {
          text: "Impostos",
          value: "valorImpostos",
          sortable: false,
          class: "px-2"
        },
        {
          text: "Valor Liquido",
          value: "valorLiquido",
          sortable: false,
          class: "px-2"
        },
        {
          text: "Valor Previsto",
          value: "valorPrevisto",
          sortable: false,
          class: "px-2"
        }
      ]
    };
  },
  computed: {
    ...portalStore.mapState([
      "initialStateFaturaSelected",
      "numberOfElementsFaturas"
    ])
  },
  methods: {
    ...portalStore.mapMutations(["updateField"]),
    updateValorEntrada(value) {
      const newValue = value
        .replace(".", "")
        .replace(",", "")
        .replace(/\D/g, "");

      if (newValue === "") {
        this.$refs.valorEntradaField.lazyValue = "0,00";
        this.updateField({
          property: "valorEntrada",
          value: "0,00"
        });
        return;
      }

      const options = { minimumFractionDigits: 2 };

      const valorFormatado = new Intl.NumberFormat("pt-BR", options).format(
        parseFloat(newValue) / 100
      );

      this.$refs.valorEntradaField.lazyValue = valorFormatado || "0,00";
      this.updateField({
        property: "valorEntrada",
        value: valorFormatado || "0,00"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-datatable td {
  padding: 0 8px !important;
}
</style>
